import {
  GLB_FILE,
  GLB_FILE_FAILURE,
  GLB_FILE_SUCCESS,
} from "../types";

export const getglbfile = (payload) => ({
  type: GLB_FILE,
  payload
});
export const getglbfileSuccess = (payload) => ({
  type: GLB_FILE_SUCCESS,
  payload,
});
export const getglbfileFailure = (payload) => ({
  type: GLB_FILE_FAILURE,
  payload,
});
